import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { usePanel } from "./PanelLayout";
import { rm } from "@/lib/api";

const today = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kuala_Lumpur" });

export default function Report() {
  const { req } = usePanel();
  const [date, setDate] = useState(today());
  const [rep, setRep] = useState(null);
  useEffect(() => { req("get", `/staff/report?date=${date}`).then(setRep); }, [req, date]);

  return (
    <div className="space-y-6 rise">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <h2 className="font-display text-2xl font-bold">Laporan Jualan Harian</h2>
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="report-date-input" className="h-10 px-3 rounded-lg border bg-white text-sm" />
      </div>
      {rep && (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-white rounded-2xl border p-5"><p className="text-xs text-slate-500">Jumlah Pesanan</p><p className="font-display text-3xl font-extrabold" data-testid="report-total-orders">{rep.total_orders}</p></div>
            <div className="bg-white rounded-2xl border p-5"><p className="text-xs text-slate-500">Jumlah Jualan</p><p className="font-display text-3xl font-extrabold text-[#B91C1C]" data-testid="report-total-sales">{rm(rep.total_sales)}</p></div>
            <div className="bg-white rounded-2xl border p-5"><p className="text-xs text-slate-500">Purata / Pesanan</p><p className="font-display text-3xl font-extrabold">{rm(rep.total_orders ? rep.total_sales / rep.total_orders : 0)}</p></div>
          </div>
          <div className="grid lg:grid-cols-2 gap-6">
            <div className="bg-white rounded-2xl border p-5">
              <h3 className="font-display font-bold mb-4">Jualan Mengikut Jam</h3>
              <div className="h-64">
                <ResponsiveContainer>
                  <BarChart data={rep.hourly}><XAxis dataKey="hour" fontSize={11} /><YAxis fontSize={11} /><Tooltip formatter={(v) => rm(v)} /><Bar dataKey="sales" fill="#B91C1C" radius={[6, 6, 0, 0]} /></BarChart>
                </ResponsiveContainer>
              </div>
            </div>
            <div className="bg-white rounded-2xl border p-5">
              <h3 className="font-display font-bold mb-4">Menu Terlaris</h3>
              <table className="w-full text-sm" data-testid="report-top-items">
                <thead><tr className="text-left text-slate-500 border-b"><th className="py-2">Menu</th><th>Kuantiti</th><th className="text-right">Jualan</th></tr></thead>
                <tbody>
                  {rep.top_items.map((t) => <tr key={t.name} className="border-b last:border-0"><td className="py-2">{t.name}</td><td>{t.qty}</td><td className="text-right font-semibold">{rm(t.sales)}</td></tr>)}
                  {!rep.top_items.length && <tr><td colSpan={3} className="py-6 text-center text-slate-500">Tiada jualan.</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
